var app = angular.module("leonardo");

var ReportsBillingListFilters = function(
  $scope,
  $rootScope,
  $controller,
  $timeout,
  ReportService
) {

  $controller('ReportsFilters', { $scope: $scope });

  $scope.filters_valid = ReportService.filtersBilling;

  $scope.filterService.clearFilters();

  $scope.filters_options = [];

  $scope.initOptions = function() {
    $scope.filters_options = [
      {
        group: 'hierarchy',
        name: 'By Hierarchy',
        elements: [
          {
            id: 'account_reports',
            name: 'Account',
            label: 'Account',
            inline: false,
            type: 'options',
            multiple: true,
            placeholder: 'All Accounts',
            condition: $scope.filterService.accounts.length > 1,
            options: $scope.filterService.accounts,
            conflicts: ['property_reports', 'portfolio_reports', 'group_reports', 'managed_by_reports']
          }
        ]
      }
    ];
  };

  $scope.initOptions();

  $rootScope.$broadcast('filters-report:initialized');

  $timeout(function() {
    $rootScope.$broadcast('validFilters:updated', $scope.getValidFilters);
    $rootScope.$broadcast('filters-valid:updated', $scope.filters_valid);
    $rootScope.$broadcast('report-type:updated', ReportService.TYPE_BILLING);
  }, 100);

};

app.controller('ReportsBillingListFilters', [
  '$scope',
  '$rootScope',
  '$controller',
  '$timeout',
  'ReportService',
  ReportsBillingListFilters
]);
